import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ expeditedUserName: string }>;

export const DispatchExpeditedUserName: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/ExpeditedUserName",
        expeditedUserName: props.parameter.expeditedUserName,
    });
};

export const chain = [DispatchExpeditedUserName];

const setExpeditedUserName = createHandlerChainRunner(chain, "setExpeditedUserName");
export default setExpeditedUserName;
